// Mock data for the digital agency portfolio website

export const services = [
  {
    id: 1,
    title: "Website Design & Development",
    slug: "website-design",
    description: "Custom, responsive websites that convert visitors into customers. Built with modern technologies for speed and performance.",
    benefits: [
      "Mobile-first responsive design",
      "SEO-optimized structure",
      "Fast loading times",
      "Modern, clean aesthetics"
    ],
    icon: "Layout"
  },
  {
    id: 2,
    title: "Website Redesign",
    slug: "website-redesign",
    description: "Transform your outdated website into a modern, high-converting digital experience that reflects your brand.",
    benefits: [
      "Fresh, contemporary look",
      "Improved user experience",
      "Better conversion rates",
      "Updated technology stack"
    ],
    icon: "RefreshCw"
  },
  {
    id: 3,
    title: "Instagram & Facebook Setup",
    slug: "social-media-setup",
    description: "Professional social media profile creation that establishes your brand presence and attracts your target audience.",
    benefits: [
      "Brand-consistent profiles",
      "Optimized bio and content",
      "Strategic hashtag research",
      "Profile optimization"
    ],
    icon: "Share2"
  },
  {
    id: 4,
    title: "Social Media Management",
    slug: "social-media-management",
    description: "Comprehensive Instagram and Facebook management to grow your audience and drive engagement.",
    benefits: [
      "Content creation & scheduling",
      "Community management",
      "Performance analytics",
      "Growth strategies"
    ],
    icon: "TrendingUp"
  }
];

export const projects = [
  {
    id: 1,
    name: "MixTV",
    description: "Comprehensive IPTV streaming platform with modern interface and seamless user experience.",
    result: "Designed to maximize user engagement and streamline the subscription flow.",
    url: "https://mixtv.co",
    category: "Web Development",
    tags: ["Website", "IPTV", "Streaming"],
    image: "/projects/mixtv.jpg"
  },
  {
    id: 2,
    name: "IPTV HQ",
    description: "Premium IPTV service platform featuring advanced streaming capabilities and user management.",
    result: "Built to improve conversion rates and simplify the user onboarding process.",
    url: "https://iptvhq.co",
    category: "Web Development",
    tags: ["Website", "IPTV", "E-commerce"],
    image: "/projects/iptvhq.jpg"
  },
  {
    id: 3,
    name: "Want2 Travel",
    description: "Travel discovery platform helping users find and plan their perfect destinations.",
    result: "Crafted to enhance travel discovery and drive booking inquiries.",
    url: "https://want2.travel",
    category: "Web Development",
    tags: ["Website", "Travel", "Booking"],
    image: "/projects/want2travel.jpg"
  },
  {
    id: 4,
    name: "Donna Puo",
    description: "Elegant e-commerce platform for fashion and lifestyle products with seamless shopping experience.",
    result: "Optimized to boost product visibility and increase purchase conversions.",
    url: "https://donnapuo.com",
    category: "Web Development",
    tags: ["E-commerce", "Fashion", "Website"],
    image: "/projects/donnapuo.jpg"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Sarah Johnson",
    role: "Founder, Boutique Fashion Brand",
    content: "Working with this team transformed our online presence. Our new website is stunning and our sales have increased by 40% in just three months.",
    rating: 5
  },
  {
    id: 2,
    name: "Michael Chen",
    role: "Restaurant Owner",
    content: "They managed our Instagram and Facebook perfectly. Our follower count doubled and we're getting consistent reservations through social media now.",
    rating: 5
  },
  {
    id: 3,
    name: "Lisa Rodriguez",
    role: "CEO, Travel Agency",
    content: "Professional, creative, and always deliver on time. They understood our vision and brought it to life better than we imagined.",
    rating: 5
  }
];

export const teamMembers = [
  {
    id: 1,
    name: "Dunja",
    role: "Creative Director & Designer",
    bio: "With a keen eye for design and user experience, Dunja leads our creative vision and ensures every project reflects modern aesthetics and functionality."
  },
  {
    id: 2,
    name: "Sava",
    role: "Lead Developer",
    bio: "Sava brings technical expertise and innovative solutions to every project, specializing in building fast, scalable, and secure web applications."
  },
  {
    id: 3,
    name: "Marko",
    role: "Social Media Strategist",
    bio: "Marko crafts engaging social media strategies that drive real results, helping businesses grow their online presence and connect with their audience."
  }
];

export const companyInfo = {
  name: process.env.REACT_APP_COMPANY_NAME || "Web Growth Studio",
  tagline: "Your Digital Partner for Growth",
  description: "We're a small but mighty team of three passionate digital professionals dedicated to helping businesses and individuals thrive online. From stunning websites to strategic social media management, we deliver results that matter.",
  whatsapp: process.env.REACT_APP_WHATSAPP_NUMBER || "+381617515710",
  phone: "+381 61 751 5710",
  email: process.env.REACT_APP_CONTACT_EMAIL || "info@webgrowthstudio.com",
  address: "Belgrade, Serbia - Working Remotely Worldwide",
  website: "https://webgrowthstudio.com"
};
